import { Box } from "@chakra-ui/react";
import type {
  EspdResponseDto,
  PortalSourcingEventDetailDto,
} from "../../../../../autogen/bff-api";
import { StepNavigation } from "../../../../../common/StepNavigation";
import { useEditor } from "../../../../../common/editing/save-coordinator";
import { EspdExclusionCriteriaList } from "../espd/EspdExclusionCriteriaList";
import { emptyEspd } from "../espd/useEspdAnswers";

// Shared between the bid wizard and the participation-request wizard: both editors carry an
// espdResponse, which is all this step touches.
type EspdHolder = { espdResponse?: EspdResponseDto | null };
type EspdHolderPatch = { espdResponse?: EspdResponseDto };

interface Props {
  entityId: string;
  event: PortalSourcingEventDetailDto;
  readOnly: boolean;
  previousStep?: () => void;
  nextStep?: () => void;
  nextStepLabel?: string;
}

export const ExclusionStep = ({
  entityId,
  event,
  readOnly,
  previousStep,
  nextStep,
  nextStepLabel,
}: Props) => {
  const { state, updateField, fieldStatus } = useEditor<
    EspdHolder,
    EspdHolderPatch
  >(entityId);
  const espd: EspdResponseDto = state.espdResponse ?? emptyEspd();

  return (
    <Box pb="8" pt="6">
      <EspdExclusionCriteriaList
        criteria={event.applicableExclusionCriteria ?? []}
        espd={espd}
        onChange={(next) => updateField({ espdResponse: next }, { debounceMs: 300 })}
        readOnly={readOnly}
        isSaving={
          fieldStatus("espdResponse") === "saving" ||
          fieldStatus("espdResponse") === "pending"
        }
      />
      <Box mt="8">
        <StepNavigation
          onPrevious={previousStep}
          onNext={nextStep}
          nextLabel={nextStepLabel}
        />
      </Box>
    </Box>
  );
};
